module.exports = __webpack_public_path__ + "static/media/handshake.5e5133e6.svg";